import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import React from "react";

function SubscriptionDetailCentroFamiglia({
  userSubscriptions,
  toggleModalShowFile,
  toggleModalAdd,
  setFile,
  setFileSettings,
  setshowModalModify,
  isOperator,
}) {
  return (
    <>
      <div className="card-wrapper card-space">
        <div className="card card-bg no-after card-big roundedCustom">
          <div className="card-body">
            {isOperator ? (
              <>
                {userSubscriptions?.state === "ADDED" && (
                  <div className="alert alert-info mt-2">
                    In attesa della compilazione della scheda di invio, firmata
                    dall'utente e protocollata, a cura dell’operatore comunale.
                  </div>
                )}
                {userSubscriptions?.state === "LOADED" && (
                  <div className="row align-items-center justify-content-center mb-4">
                    <button
                      type="button"
                      className="btn btn-primary text-success w-50 p-2 py-3"
                      onClick={() => {
                        setshowModalModify(true);
                      }}
                    >
                      <svg className="icon icon-white">
                        <use href={`${iconSprite}#it-pencil`} />
                      </svg>{" "}
                      <span className="align-middle text-white">
                        Esito Valutazione
                      </span>
                    </button>
                  </div>
                )}
                {userSubscriptions?.state === "VALIDATED" && (
                  <div className="alert alert-success mt-2">
                    <div className="row">
                      <strong>Validato</strong>
                      {userSubscriptions?.nProtocolloUscita && (
                        <div className="col-3">
                          N. Protocollo Uscita:{" "}
                          <strong className="ml-1">
                            {userSubscriptions?.nProtocolloUscita}
                          </strong>
                        </div>
                      )}
                      <div className="col text-right">
                        <button
                          type="button"
                          className="btn btn-outline-primary text-success  p-2"
                          onClick={() => {
                            setshowModalModify(true);
                          }}
                          title="Modifica iscrizione"
                        >
                          <svg className="icon icon-primary">
                            <use href={`${iconSprite}#it-pencil`} />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <>
                {" "}
                {userSubscriptions?.state === "ADDED" && (
                  <div className="alert alert-info mt-2">
                    Per procedere con la revisione dell'iscrizione, è necessario
                    caricare l'atto firmato.
                  </div>
                )}{" "}
                {userSubscriptions?.state === "LOADED" && (
                  <div className="alert alert-info mt-2">
                    In Attesa di revisione da parte dell'ufficio di piano
                  </div>
                )}
                {userSubscriptions?.state === "VALIDATED" && (
                  <div className="alert alert-success mt-2">
                    <div className="row">
                      <strong>Validato</strong>
                      {userSubscriptions?.nProtocolloUscita && (
                        <div className="col-3">
                          N. Protocollo Uscita:{" "}
                          <strong className="ml-1">
                            {userSubscriptions?.nProtocolloUscita}
                          </strong>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </>
            )}
            <h4>Scheda invio</h4>
            <div className="container">
              <div className="row row-cols-2">
                <div className="col border-right">
                  {" "}
                  <div className="container mb-5">
                    {userSubscriptions &&
                    userSubscriptions.subscriptionFiles.filter(
                      (x) => x.description === "schedaInvio",
                    ).length > 0 ? (
                      userSubscriptions.subscriptionFiles
                        .filter((x) => x.description === "schedaInvio")
                        .map((allegato, index) => (
                          <React.Fragment key={index}>
                            <div className="categoryicon-top">
                              <span className="text">
                                <a
                                  href="#"
                                  className="text-decoration-none font-weight-bold"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setFile({
                                      data:
                                        "data:application/pdf;base64," +
                                        allegato?.storageFile?.file,
                                    });
                                    toggleModalShowFile(true);
                                  }}
                                >
                                  <svg className="icon">
                                    <use href={`${iconSprite}#it-clip`}></use>
                                  </svg>
                                  {allegato.storageFile.name}
                                </a>

                                <br />
                              </span>
                            </div>

                            <p className="card-text font-serif">
                              {allegato.description === "fileDaFirmare" ? (
                                <>Atto da firmare</>
                              ) : (
                                <></>
                              )}
                            </p>
                          </React.Fragment>
                        ))
                    ) : (
                      <>Non ci sono contratti.</>
                    )}
                  </div>
                </div>
                <div className="col">
                  {userSubscriptions.subscriptionFiles.filter(
                    (x) => x.description === "fileFirmato",
                  ).length > 0 ? (
                    <>
                      {userSubscriptions.subscriptionFiles
                        .filter((x) => x.description === "fileFirmato")
                        .map((allegatoFirmato, index) => (
                          <div className="row" key={index}>
                            <div className="col-10">
                              <div className="categoryicon-top">
                                <span className="text">
                                  <a
                                    href="#"
                                    className="text-decoration-none font-weight-bold"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setFile({
                                        data:
                                          "data:application/pdf;base64," +
                                          allegatoFirmato?.storageFile?.file,
                                      });
                                      toggleModalShowFile(true);
                                    }}
                                  >
                                    <svg className="icon">
                                      <use href={`${iconSprite}#it-clip`}></use>
                                    </svg>
                                    {allegatoFirmato.storageFile.name}
                                  </a>

                                  <br />
                                </span>
                              </div>
                            </div>
                            <div className="col-1">
                              <button
                                type="button"
                                className={
                                  userSubscriptions?.state === "VALIDATED"
                                    ? "border btn btn-outline-primary text-success  p-2"
                                    : "btn btn-outline-primary text-success  p-2"
                                }
                                onClick={() => {
                                  toggleModalAdd(true);
                                  setFileSettings({
                                    title:
                                      "Scheda di invio firmata dall'utente e protocollato",
                                    description: "fileFirmato",
                                    fileName: "fileFirmato",
                                  });
                                }}
                                aria-label="Carica la scheda di invio firmata dall'utente e protocollato"
                                disabled={
                                  userSubscriptions?.state === "VALIDATED"
                                }
                                title={
                                  userSubscriptions?.state === "VALIDATED"
                                    ? "Non si possono apportare modifiche alle iscrizioni validate"
                                    : "Sovrascrivi la scheda di invio firmata dall'utente e protocollato"
                                }
                              >
                                <svg className="icon icon-primary">
                                  <use href={`${iconSprite}#it-upload`} />
                                </svg>
                              </button>
                            </div>
                          </div>
                        ))}
                    </>
                  ) : (
                    <div className="align-self-center text-center">
                      <button
                        type="button"
                        className={
                          userSubscriptions?.state === "VALIDATED"
                            ? "border btn btn-outline-primary text-success  p-2"
                            : "btn btn-outline-primary text-success  p-2"
                        }
                        onClick={() => {
                          toggleModalAdd(true);
                          setFileSettings({
                            title:
                              "scheda di invio firmata dall'utente e protocollato",
                            description: "fileFirmato",
                            fileName: "fileFirmato",
                          });
                        }}
                        disabled={userSubscriptions?.state === "VALIDATED"}
                        title={
                          userSubscriptions?.state === "VALIDATED"
                            ? "Non si possono apportare modifiche alle iscrizioni validate"
                            : "Carica la scheda di invio firmata dall'utente e protocollato"
                        }
                      >
                        <svg className="icon icon-primary">
                          <use href={`${iconSprite}#it-upload`} />
                        </svg>{" "}
                        <span className="align-middle">
                          Carica la scheda di invio firmata dall'utente e
                          protocollato
                        </span>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SubscriptionDetailCentroFamiglia;
